import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=36ee88f6&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=js"
export * from "./editPhone.vue?vue&type=script&lang=js"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=36ee88f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee88f6",
  null
  
)

export default component.exports